(function() {
  // Function to sync active thumbnail with gallery scroll
  function syncThumbnailOnScroll() {
    const gallery = document.querySelector('[data-pg]');
    if (!gallery) return;

    const mainSlides = gallery.querySelector('[data-pg-main-slides]');
    const thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    
    if (!mainSlides || !thumbSlides) return;

    let scrollTimeout;
    let rafId = null;
    let lastActiveIndex = null;
    let isUpdating = false;
    let isInitializing = true;
    let navigatingToOrigin = null;
    let navigatingToOriginClearTimer = null;
    let initialSetupComplete = false;
    let isLoopCloneUpdate = false;
    let loopWrapPending = false;
    let loopRebuildTimer = null;

    function getRealSlides() {
      return Array.from(mainSlides.children).filter(function (slide) {
        return slide.dataset.originIndex && !slide.dataset.pgLoopClone;
      });
    }

    function removeLoopClones() {
      mainSlides.querySelectorAll('[data-pg-loop-clone]').forEach(function (clone) {
        clone.remove();
      });
    }

    function sanitizeLoopClone(clone, loopOrigin) {
      clone.setAttribute('data-pg-loop-clone', 'true');
      clone.setAttribute('data-loop-origin', loopOrigin);
      clone.removeAttribute('data-origin-index');
      clone.classList.remove('active');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('[id]').forEach(function (el) {
        el.removeAttribute('id');
      });

      clone.querySelectorAll('iframe').forEach(function (iframe) {
        iframe.src = 'about:blank';
        iframe.style.pointerEvents = 'none';
      });

      clone.querySelectorAll('video').forEach(function (video) {
        video.pause();
        video.removeAttribute('autoplay');
        video.style.pointerEvents = 'none';
      });
    }

    function rebuildLoopClones(preserveOrigin) {
      if (loopWrapPending) return;

      const realSlides = getRealSlides();
      if (realSlides.length < 2) {
        removeLoopClones();
        return;
      }

      const first = realSlides[0];
      const last = realSlides[realSlides.length - 1];
      const anchorOrigin = preserveOrigin || (getActiveSlideFromScroll() && getActiveSlideFromScroll().dataset.originIndex) || first.dataset.originIndex;

      isLoopCloneUpdate = true;
      removeLoopClones();

      const leadingClone = last.cloneNode(true);
      const trailingClone = first.cloneNode(true);
      sanitizeLoopClone(leadingClone, last.dataset.originIndex);
      sanitizeLoopClone(trailingClone, first.dataset.originIndex);

      mainSlides.insertBefore(leadingClone, first);
      mainSlides.appendChild(trailingClone);

      requestAnimationFrame(function () {
        const anchor = mainSlides.querySelector('[data-origin-index="' + anchorOrigin + '"]');
        if (anchor) {
          mainSlides.scrollLeft = anchor.offsetLeft;
        } else {
          mainSlides.scrollLeft = first.offsetLeft;
        }
        isLoopCloneUpdate = false;
      });
    }

    function scheduleLoopCloneRebuild(preserveOrigin) {
      clearTimeout(loopRebuildTimer);
      loopRebuildTimer = setTimeout(function () {
        if (!isLoopCloneUpdate) {
          rebuildLoopClones(preserveOrigin);
        }
      }, 150);
    }

    function getVisibleSlideFromScroll() {
      const slides = Array.from(mainSlides.children);
      if (!slides.length) return null;
      const sl = mainSlides.scrollLeft;
      let best = slides[0];
      let bestDist = Math.abs(slides[0].offsetLeft - sl);
      for (let i = 1; i < slides.length; i++) {
        const d = Math.abs(slides[i].offsetLeft - sl);
        if (d < bestDist) {
          bestDist = d;
          best = slides[i];
        }
      }
      return best;
    }

    function checkInfiniteScrollWrap() {
      if (loopWrapPending || isInitializing || isLoopCloneUpdate) return;

      const visibleSlide = getVisibleSlideFromScroll();
      if (!visibleSlide || !visibleSlide.dataset.pgLoopClone) return;

      const origin = visibleSlide.dataset.loopOrigin;
      if (!origin) return;

      const realTarget = mainSlides.querySelector('[data-origin-index="' + origin + '"]');
      if (!realTarget) return;

      loopWrapPending = true;
      mainSlides.scrollLeft = realTarget.offsetLeft;
      requestAnimationFrame(function () {
        loopWrapPending = false;
        updateActiveThumbnail(true);
        tryPlayCustomMp4IfVisibleInGallery();
      });
    }
    
    // Helper function to handle video visibility and autoplay
    // Note: Browser autoplay policies may prevent autoplay in some cases:
    // - Videos must be muted (mute=1) for autoplay to work in most browsers
    // - Some browsers require user interaction before autoplay is allowed
    // - Mobile browsers have stricter autoplay policies
    function handleVideoSlide(videoSlide) {
      if (!videoSlide || videoSlide.dataset.originIndex !== 'video') return;
      
      requestAnimationFrame(() => {
        const videoId = gallery.dataset.videoId;
        if (!videoId) return;
        
        const videoContainer = videoSlide.querySelector('.w-full.relative') || videoSlide.firstElementChild;
        if (!videoContainer) return;
        
        // Find and hide the thumbnail wrapper
        const thumbnailWrapper = videoContainer.querySelector('div.block');
        if (thumbnailWrapper) {
          thumbnailWrapper.style.setProperty('display', 'none', 'important');
          thumbnailWrapper.style.setProperty('opacity', '0', 'important');
          thumbnailWrapper.style.setProperty('visibility', 'hidden', 'important');
          thumbnailWrapper.style.setProperty('pointer-events', 'none', 'important');
          thumbnailWrapper.style.setProperty('position', 'absolute', 'important');
          thumbnailWrapper.style.setProperty('z-index', '-1', 'important');
        }
        
        const thumbnailImg = videoContainer.querySelector('img');
        if (thumbnailImg) {
          thumbnailImg.style.setProperty('display', 'none', 'important');
          thumbnailImg.style.setProperty('opacity', '0', 'important');
          thumbnailImg.style.setProperty('visibility', 'hidden', 'important');
          thumbnailImg.style.setProperty('z-index', '-1', 'important');
        }
        
        // Build the YouTube URL with all required parameters for autoplay
        const autoplayUrl = `https://www.youtube.com/embed/${videoId}?playlist=${videoId}&loop=1&rel=0&iv_load_policy=3&modestbranding=1&controls=1&showinfo=0&mute=1&autoplay=1&enablejsapi=1`;
        
        let videoFrame = videoSlide.querySelector('#gallery_video');
        
        if (videoFrame) {
          // Aggressively remove ALL possible visibility-hiding classes
          const classesToRemove = ['opacity-0', 'invisible', 'hidden', 'opacity-0!', 'invisible!', 'hidden!', '!opacity-0', '!invisible', '!hidden'];
          classesToRemove.forEach(cls => {
            videoFrame.classList.remove(cls);
          });
          
          // Add visibility classes
          videoFrame.classList.add('opacity-100', 'visible', 'block');
          
          // Set ALL inline styles with !important to ensure visibility and override any CSS
          videoFrame.style.setProperty('opacity', '1', 'important');
          videoFrame.style.setProperty('visibility', 'visible', 'important');
          videoFrame.style.setProperty('display', 'block', 'important');
          videoFrame.style.setProperty('z-index', '10', 'important');
          videoFrame.style.setProperty('position', 'absolute', 'important');
          videoFrame.style.setProperty('top', '0', 'important');
          videoFrame.style.setProperty('left', '0', 'important');
          videoFrame.style.setProperty('right', '0', 'important');
          videoFrame.style.setProperty('bottom', '0', 'important');
          videoFrame.style.setProperty('width', '100%', 'important');
          videoFrame.style.setProperty('height', '100%', 'important');
          videoFrame.style.setProperty('pointer-events', 'auto', 'important');
          videoFrame.style.setProperty('transform', 'none', 'important');
          videoFrame.style.setProperty('clip', 'auto', 'important');
          videoFrame.style.setProperty('clip-path', 'none', 'important');
          
          // Force a reflow to ensure styles are applied
          void videoFrame.offsetHeight;
          
          // Recreate iframe to ensure autoplay works (changing src doesn't always trigger autoplay)
          // Check if we need to reload for autoplay
          if (!videoFrame.src.includes('autoplay=1') || videoFrame.src !== autoplayUrl) {
            // Remove old iframe
            const parent = videoFrame.parentNode;
            videoFrame.remove();
            
            // Create new iframe with autoplay
            videoFrame = document.createElement('iframe');
            videoFrame.id = 'gallery_video';
            videoFrame.className = 'absolute inset-0 opacity-100 visible block';
            videoFrame.src = autoplayUrl;
            videoFrame.width = '100%';
            videoFrame.height = '100%';
            videoFrame.frameBorder = '0';
            videoFrame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
            videoFrame.setAttribute('allowfullscreen', '');
            
            // Set ALL inline styles with !important
            videoFrame.style.setProperty('opacity', '1', 'important');
            videoFrame.style.setProperty('visibility', 'visible', 'important');
            videoFrame.style.setProperty('display', 'block', 'important');
            videoFrame.style.setProperty('z-index', '10', 'important');
            videoFrame.style.setProperty('position', 'absolute', 'important');
            videoFrame.style.setProperty('top', '0', 'important');
            videoFrame.style.setProperty('left', '0', 'important');
            videoFrame.style.setProperty('right', '0', 'important');
            videoFrame.style.setProperty('bottom', '0', 'important');
            videoFrame.style.setProperty('width', '100%', 'important');
            videoFrame.style.setProperty('height', '100%', 'important');
            videoFrame.style.setProperty('pointer-events', 'auto', 'important');
            videoFrame.style.setProperty('transform', 'none', 'important');
            videoFrame.style.setProperty('clip', 'auto', 'important');
            videoFrame.style.setProperty('clip-path', 'none', 'important');
            
            // Append new iframe
            videoContainer.appendChild(videoFrame);
          }
        } else {
          // If iframe doesn't exist, create it with autoplay
          const videoIframe = document.createElement('iframe');
          videoIframe.id = 'gallery_video';
          videoIframe.className = 'absolute inset-0 opacity-100 visible block';
          videoIframe.src = autoplayUrl;
          videoIframe.width = '100%';
          videoIframe.height = '100%';
          videoIframe.frameBorder = '0';
          videoIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
          videoIframe.setAttribute('allowfullscreen', '');
          
          // Set ALL inline styles with !important
          videoIframe.style.setProperty('opacity', '1', 'important');
          videoIframe.style.setProperty('visibility', 'visible', 'important');
          videoIframe.style.setProperty('display', 'block', 'important');
          videoIframe.style.setProperty('z-index', '10', 'important');
          videoIframe.style.setProperty('position', 'absolute', 'important');
          videoIframe.style.setProperty('top', '0', 'important');
          videoIframe.style.setProperty('left', '0', 'important');
          videoIframe.style.setProperty('right', '0', 'important');
          videoIframe.style.setProperty('bottom', '0', 'important');
          videoIframe.style.setProperty('width', '100%', 'important');
          videoIframe.style.setProperty('height', '100%', 'important');
          videoIframe.style.setProperty('pointer-events', 'auto', 'important');
          videoIframe.style.setProperty('transform', 'none', 'important');
          videoIframe.style.setProperty('clip', 'auto', 'important');
          videoIframe.style.setProperty('clip-path', 'none', 'important');
          
          videoContainer.appendChild(videoIframe);
        }
      });
    }

    function forceInlineMutedAutoplayAttrs(video) {
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.playsInline = true;
      video.loop = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function trySafariSafePlay(video, retries) {
      if (!video) return;
      forceInlineMutedAutoplayAttrs(video);
      const playPromise = video.play();
      if (!playPromise || typeof playPromise.catch !== 'function') return;
      playPromise.catch(function () {
        if (!retries || retries <= 0) return;
        setTimeout(function () {
          trySafariSafePlay(video, retries - 1);
        }, 120);
      });
    }

    function warmupCustomMp4(video) {
      if (!video) return;
      forceInlineMutedAutoplayAttrs(video);
      // Ask browser to fetch media ASAP so playback starts faster when visible.
      if (video.preload !== 'auto') {
        video.preload = 'auto';
        video.setAttribute('preload', 'auto');
      }
      if (video.readyState < 2) {
        try {
          video.load();
        } catch (e) {}
      }
    }

    function isElementVisibleInViewport(el) {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      const vw = window.innerWidth || document.documentElement.clientWidth;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > 0 && r.right > 0 && r.top < vh && r.left < vw;
    }

    function isMp4Origin(originIndex) {
      return originIndex === 'custom-video' || originIndex === 'variant-video';
    }

    function pauseInactiveMp4Videos(activeOriginIndex) {
      mainSlides.querySelectorAll('[data-origin-index="custom-video"], [data-origin-index="variant-video"]').forEach(function (slide) {
        if (slide.dataset.originIndex === activeOriginIndex) return;
        const video = slide.querySelector('video');
        if (video) video.pause();
      });
    }

    /** MP4 metafields: autoplay muted; no pause once started (productGallery también deja de pausar al cambiar thumb). */
    function handleCustomMp4Slide(mp4Slide) {
      if (!mp4Slide || !isMp4Origin(mp4Slide.dataset.originIndex)) return;
      const video = mp4Slide.querySelector('video');
      if (!video) return;
      warmupCustomMp4(video);
      if (!video.dataset.pgAutoplayBound) {
        video.addEventListener('loadedmetadata', function () {
          trySafariSafePlay(video, 2);
        }, { passive: true });
        video.addEventListener('loadeddata', function () {
          trySafariSafePlay(video, 2);
        }, { passive: true });
        video.addEventListener('canplay', function () {
          trySafariSafePlay(video, 2);
        }, { passive: true });
        video.dataset.pgAutoplayBound = 'true';
      }
      video.classList.remove('opacity-0', 'invisible');
      video.classList.add('opacity-100', 'visible');
      trySafariSafePlay(video, 4);
    }

    /** True if any part of the slide is visible inside the horizontal gallery strip */
    function isCustomVideoSlidePeekingInGallery(mp4Slide) {
      if (!mp4Slide || !isMp4Origin(mp4Slide.dataset.originIndex)) return false;
      const er = mp4Slide.getBoundingClientRect();
      const cr = mainSlides.getBoundingClientRect();
      const w = Math.min(er.right, cr.right) - Math.max(er.left, cr.left);
      const h = Math.min(er.bottom, cr.bottom) - Math.max(er.top, cr.top);
      return w > 2 && h > 2;
    }

    function tryPlayCustomMp4IfVisibleInGallery() {
      mainSlides.querySelectorAll('[data-origin-index="custom-video"], [data-origin-index="variant-video"]').forEach(function (slide) {
        if (isCustomVideoSlidePeekingInGallery(slide) && isElementVisibleInViewport(slide)) {
          handleCustomMp4Slide(slide);
        }
      });
    }

    let customMp4VisibilityObserver = null;
    let customMp4ViewportObserver = null;
    function setupCustomMp4VisibilityPlay() {
      if (!('IntersectionObserver' in window)) {
        tryPlayCustomMp4IfVisibleInGallery();
        return;
      }
      const mp4Slides = mainSlides.querySelectorAll('[data-origin-index="custom-video"], [data-origin-index="variant-video"]');
      if (customMp4VisibilityObserver) {
        customMp4VisibilityObserver.disconnect();
        customMp4VisibilityObserver = null;
      }
      if (!mp4Slides.length) return;
      /* Max ~15 thresholds in some browsers; scroll + tryPlay cubre hendiduras */
      var thresholds = [0, 0.01, 0.02, 0.03, 0.05, 0.08, 0.1, 0.15, 0.22, 0.3, 0.45, 0.55, 0.7, 0.88, 1];
      customMp4VisibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.001) return;
            if (!isElementVisibleInViewport(entry.target)) return;
            handleCustomMp4Slide(entry.target);
          });
        },
        { root: mainSlides, rootMargin: '0px', threshold: thresholds }
      );
      mp4Slides.forEach(function (slide) {
        const video = slide.querySelector('video');
        warmupCustomMp4(video);
        customMp4VisibilityObserver.observe(slide);
      });

      if (customMp4ViewportObserver) {
        customMp4ViewportObserver.disconnect();
        customMp4ViewportObserver = null;
      }
      // Start as soon as the gallery area enters viewport.
      customMp4ViewportObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.001) return;
            if (!isCustomVideoSlidePeekingInGallery(entry.target)) return;
            handleCustomMp4Slide(entry.target);
          });
        },
        { root: null, rootMargin: '120px 0px', threshold: [0.01, 0.1, 0.25] }
      );
      mp4Slides.forEach(function (slide) {
        customMp4ViewportObserver.observe(slide);
      });
      tryPlayCustomMp4IfVisibleInGallery();
    }
    
    /** Slide aligned with current scroll; loop clones resolve to their real slide */
    function getActiveSlideFromScroll() {
      const realSlides = getRealSlides();
      if (!realSlides.length) return null;

      const visibleSlide = getVisibleSlideFromScroll();
      if (!visibleSlide) return realSlides[0];

      if (visibleSlide.dataset.pgLoopClone) {
        const origin = visibleSlide.dataset.loopOrigin;
        return mainSlides.querySelector('[data-origin-index="' + origin + '"]') || realSlides[0];
      }

      return visibleSlide.dataset.originIndex ? visibleSlide : realSlides[0];
    }

    function updateActiveThumbnail(skipChangeCheck = false) {
      // Prevent concurrent updates
      if (isUpdating) return;
      
      const activeSlide = getActiveSlideFromScroll();
      if (!activeSlide) return;

      const originIndex = activeSlide.dataset.originIndex;
      if (!originIndex) return;

      if (!skipChangeCheck && lastActiveIndex === originIndex) {
        return;
      }

      isUpdating = true;
      lastActiveIndex = originIndex;

      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId = requestAnimationFrame(() => {
        Array.from(mainSlides.children).forEach(slide => slide.classList.remove('active'));
        Array.from(thumbSlides.children).forEach(thumb => thumb.classList.remove('active'));

        activeSlide.classList.add('active');
        const correspondingThumb = thumbSlides.querySelector(`[data-origin-index="${originIndex}"]`);
        if (correspondingThumb) {
          correspondingThumb.classList.add('active');
        }

        if (originIndex === 'video') {
          handleVideoSlide(activeSlide);
        }
        pauseInactiveMp4Videos(originIndex);
        if (isMp4Origin(originIndex)) {
          handleCustomMp4Slide(activeSlide);
        }

        const modelInfo = activeSlide.dataset.modelInfo;
        const modelInfoElement = gallery.querySelector('[data-pg-model-info]');
        if (modelInfoElement) {
          modelInfoElement.innerHTML = modelInfo ? decodeURIComponent(modelInfo) : '';
        }

        isUpdating = false;
        rafId = null;
      });
    }
    
    function onMainSlidesScrollSettled() {
      if (isInitializing) return;
      if (navigatingToOrigin) {
        const target = mainSlides.querySelector(`[data-origin-index="${navigatingToOrigin}"]`);
        if (target) {
          const slideList = Array.from(mainSlides.children).filter(s => s.dataset.originIndex);
          const maxSl = Math.max(0, mainSlides.scrollWidth - mainSlides.clientWidth);
          const atScrollEnd =
            slideList.length &&
            target === slideList[slideList.length - 1] &&
            mainSlides.scrollLeft >= maxSl - 12;
          const delta = Math.abs(mainSlides.scrollLeft - target.offsetLeft);
          if (!atScrollEnd && delta > 80) return;
        }
        navigatingToOrigin = null;
        if (navigatingToOriginClearTimer) {
          clearTimeout(navigatingToOriginClearTimer);
          navigatingToOriginClearTimer = null;
        }
      }
      checkInfiniteScrollWrap();
      updateActiveThumbnail();
      tryPlayCustomMp4IfVisibleInGallery();
    }

    function scheduleScrollSync() {
      checkInfiniteScrollWrap();
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(onMainSlidesScrollSettled, 380);
    }

    mainSlides.addEventListener('scroll', scheduleScrollSync, { passive: true });
    mainSlides.addEventListener('scrollend', function () {
      navigatingToOrigin = null;
      if (navigatingToOriginClearTimer) {
        clearTimeout(navigatingToOriginClearTimer);
        navigatingToOriginClearTimer = null;
      }
      checkInfiniteScrollWrap();
      if (!isInitializing) {
        updateActiveThumbnail();
        tryPlayCustomMp4IfVisibleInGallery();
      }
    });

    let resizeSyncTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeSyncTimer);
      resizeSyncTimer = setTimeout(function () {
        if (!isInitializing) {
          updateActiveThumbnail(true);
          tryPlayCustomMp4IfVisibleInGallery();
        }
      }, 150);
    });

    setTimeout(() => {
      void mainSlides.offsetHeight;
      updateActiveThumbnail(true);
      setTimeout(() => {
        updateActiveThumbnail(true);
        isInitializing = false;
        initialSetupComplete = true;
        setupCustomMp4VisibilityPlay();
      }, 300);
    }, 300);

    const mutationObserver = new MutationObserver(() => {
      navigatingToOrigin = null;
      if (navigatingToOriginClearTimer) {
        clearTimeout(navigatingToOriginClearTimer);
        navigatingToOriginClearTimer = null;
      }
      isInitializing = true;
      initialSetupComplete = false;
      setTimeout(() => {
        updateActiveThumbnail(true);
        setTimeout(() => {
          isInitializing = false;
          initialSetupComplete = true;
          setupCustomMp4VisibilityPlay();
        }, 300);
      }, 100);
    });
    mutationObserver.observe(mainSlides, { childList: true });

    /** Loop última→primera / primera→última sin scroll suave intermedio */
    gallery.addEventListener('pg-loop-wrap', function (e) {
      const originIndex = e.detail && e.detail.originIndex;
      if (!originIndex) return;
      if (originIndex === 'video') {
        ensureVideoSlide();
      }
      const targetSlide = mainSlides.querySelector(`[data-origin-index="${originIndex}"]`);
      const thumb = thumbSlides.querySelector(`[data-origin-index="${originIndex}"]`);
      if (!targetSlide || !thumb) return;
      navigatingToOrigin = originIndex;
      if (navigatingToOriginClearTimer) {
        clearTimeout(navigatingToOriginClearTimer);
      }
      navigatingToOriginClearTimer = setTimeout(function () {
        navigatingToOrigin = null;
        navigatingToOriginClearTimer = null;
        if (!isInitializing) updateActiveThumbnail(true);
      }, 2200);
      Array.from(mainSlides.children).forEach(function (slide) {
        slide.classList.remove('active');
      });
      Array.from(thumbSlides.children).forEach(function (thumbEl) {
        thumbEl.classList.remove('active');
      });
      targetSlide.classList.add('active');
      thumb.classList.add('active');
      const modelInfo = targetSlide.dataset.modelInfo;
      const modelInfoElement = gallery.querySelector('[data-pg-model-info]');
      if (modelInfoElement) {
        modelInfoElement.innerHTML = modelInfo ? decodeURIComponent(modelInfo) : '';
      }
      lastActiveIndex = originIndex;
      if (originIndex === 'video') {
        handleVideoSlide(targetSlide);
      }
      if (isMp4Origin(originIndex)) {
        handleCustomMp4Slide(targetSlide);
      }
      targetSlide.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'start'
      });
      tryPlayCustomMp4IfVisibleInGallery();
    });
    
    // Add thumbnail click handlers to scroll to corresponding slide
    function bindThumbnailClicks() {
      Array.from(thumbSlides.children).forEach(thumb => {
        // Check if already has our listener
        if (thumb.dataset.hasScrollListener === 'true') return;
        
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const originIndex = thumb.dataset.originIndex;
          if (!originIndex) return;
          
          // Ensure video slide exists if clicking video thumbnail
          if (originIndex === 'video') {
            ensureVideoSlide();
          }
          
          const targetSlide = mainSlides.querySelector(`[data-origin-index="${originIndex}"]`);
          if (!targetSlide) return;
          
          navigatingToOrigin = originIndex;
          if (navigatingToOriginClearTimer) {
            clearTimeout(navigatingToOriginClearTimer);
          }
          navigatingToOriginClearTimer = setTimeout(function () {
            navigatingToOrigin = null;
            navigatingToOriginClearTimer = null;
            if (!isInitializing) updateActiveThumbnail(true);
          }, 2200);
          
          // Update active states immediately
          Array.from(mainSlides.children).forEach(slide => slide.classList.remove('active'));
          Array.from(thumbSlides.children).forEach(thumbEl => thumbEl.classList.remove('active'));
          
          targetSlide.classList.add('active');
          thumb.classList.add('active');
          
          // Update model info if available
          const modelInfo = targetSlide.dataset.modelInfo;
          const modelInfoElement = gallery.querySelector('[data-pg-model-info]');
          if (modelInfoElement) {
            modelInfoElement.innerHTML = modelInfo ? decodeURIComponent(modelInfo) : '';
          }
          
          // Update last active index
          lastActiveIndex = originIndex;
          
          // Handle YouTube video - show iframe before scrolling
          if (originIndex === 'video') {
            handleVideoSlide(targetSlide);
          }
          if (isMp4Origin(originIndex)) {
            handleCustomMp4Slide(targetSlide);
          }
          
          // Scroll to the target slide after updating visibility
          targetSlide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });
          
        });
        
        // Mark as having listener
        thumb.dataset.hasScrollListener = 'true';
      });
    }

    // Allow advancing by clicking the visible part of adjacent slides.
    function bindMainSlideClickAdvance() {
      if (mainSlides.dataset.hasClickAdvanceListener === 'true') return;
      mainSlides.addEventListener('click', function (e) {
        const clickedSlide = e.target.closest('[data-origin-index]');
        if (!clickedSlide || !mainSlides.contains(clickedSlide)) return;

        const clickedOrigin = clickedSlide.dataset.originIndex;
        if (!clickedOrigin) return;
        if (clickedSlide.classList.contains('active')) return;

        const correspondingThumb = thumbSlides.querySelector(`[data-origin-index="${clickedOrigin}"]`);
        if (!correspondingThumb) return;

        // Reuse existing thumb navigation behavior for consistency.
        correspondingThumb.click();
      });
      mainSlides.dataset.hasClickAdvanceListener = 'true';
    }
    
    // Bind thumbnail clicks after initial setup
    setTimeout(() => {
      bindThumbnailClicks();
      bindMainSlideClickAdvance();
    }, 600);
    
    // Re-bind when slides are added/removed
    const thumbnailMutationObserver = new MutationObserver(() => {
      bindThumbnailClicks();
      bindMainSlideClickAdvance();
    });
    
    thumbnailMutationObserver.observe(thumbSlides, { childList: true });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncThumbnailOnScroll);
  } else {
    syncThumbnailOnScroll();
  }
  
  // Function to recreate YouTube video slide if missing
  function ensureVideoSlide() {
    const gallery = document.querySelector('[data-pg]');
    if (!gallery || !gallery.dataset.videoId) return;
    
    const mainSlides = gallery.querySelector('[data-pg-main-slides]');
    const thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    if (!mainSlides || !thumbSlides) return;
    
    const videoId = gallery.dataset.videoId;
    let videoSlide = mainSlides.querySelector('[data-origin-index="video"]');
    
    // If video slide doesn't exist, create it
    if (!videoSlide) {
      videoSlide = document.createElement('div');
      videoSlide.className = 'product-video w-full';
      videoSlide.setAttribute('data-origin-index', 'video');
      
      const videoContainer = document.createElement('div');
      videoContainer.className = 'w-full relative';
      
      const thumbnailWrapper = document.createElement('div');
      thumbnailWrapper.className = 'block pt-[100%] group';
      
      const thumbnailImg = document.createElement('img');
      thumbnailImg.src = `https://img.youtube.com/vi/${videoId}/0.jpg`;
      thumbnailImg.alt = `product video - ${videoId}`;
      thumbnailImg.className = 'absolute w-full h-full top-0 left-0 object-cover -z-1';
      thumbnailImg.loading = 'lazy';
      
      thumbnailWrapper.appendChild(thumbnailImg);
      
      // Create YouTube iframe (matching structure from liquid template)
      const videoIframe = document.createElement('iframe');
      videoIframe.id = 'gallery_video';
      videoIframe.className = 'absolute inset-0 opacity-100 visible block';
      videoIframe.src = `https://www.youtube.com/embed/${videoId}?playlist=${videoId}&loop=1&rel=0&iv_load_policy=3&modestbranding=1&controls=1&showinfo=0&mute=1`;
      videoIframe.width = '100%';
      videoIframe.height = '100%';
      videoIframe.frameBorder = '0';
      videoIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      videoIframe.setAttribute('allowfullscreen', '');
      
      videoContainer.appendChild(thumbnailWrapper);
      videoContainer.appendChild(videoIframe);
      videoSlide.appendChild(videoContainer);
      
      // Append video slide to main slides (at the end)
      mainSlides.appendChild(videoSlide);
      
      // Force reflow to ensure styles are applied
      void videoSlide.offsetHeight;
    } else {
      // If video slide exists, ensure iframe is present
      let videoIframe = videoSlide.querySelector('#gallery_video');
      if (!videoIframe) {
        const videoContainer = videoSlide.querySelector('.w-full.relative') || videoSlide;
        videoIframe = document.createElement('iframe');
        videoIframe.id = 'gallery_video';
        videoIframe.className = 'absolute inset-0 opacity-100 visible block';
        videoIframe.src = `https://www.youtube.com/embed/${videoId}?playlist=${videoId}&loop=1&rel=0&iv_load_policy=3&modestbranding=1&controls=1&showinfo=0&mute=1`;
        videoIframe.width = '100%';
        videoIframe.height = '100%';
        videoIframe.frameBorder = '0';
        videoIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        videoIframe.setAttribute('allowfullscreen', '');
        videoContainer.appendChild(videoIframe);
      }
    }
    
    // Ensure thumbnail exists
    let videoThumb = thumbSlides.querySelector('[data-origin-index="video"]');
    if (!videoThumb) {
      videoThumb = document.createElement('div');
      videoThumb.className = 'thumbnail thumbnail--video relative';
      videoThumb.setAttribute('data-origin-index', 'video');
      thumbSlides.appendChild(videoThumb);
    }
    
    return videoSlide;
  }

  function prewarmCustomMp4OnPdpEntry() {
    const gallery = document.querySelector('[data-pg]');
    if (!gallery) return;
    gallery.querySelectorAll('[data-origin-index="custom-video"], [data-origin-index="variant-video"]').forEach(function (slide) {
      const video = slide.querySelector('video');
      if (!video) return;
      const videoSrc = video.currentSrc || video.src;

      // Hint the browser to fetch MP4 as early as possible.
      if (videoSrc && !document.querySelector(`link[rel="preload"][as="video"][href="${videoSrc}"]`)) {
        const preload = document.createElement('link');
        preload.rel = 'preload';
        preload.as = 'video';
        preload.href = videoSrc;
        preload.crossOrigin = 'anonymous';
        document.head.appendChild(preload);
      }

      if (video.preload !== 'auto') {
        video.preload = 'auto';
        video.setAttribute('preload', 'auto');
      }
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      if (video.readyState < 2) {
        try {
          video.load();
        } catch (e) {}
      }

      const primePlay = function (retriesLeft) {
        const p = video.play();
        if (!p || typeof p.catch !== 'function') return;
        p.catch(function () {
          if (!retriesLeft || retriesLeft <= 0) return;
          setTimeout(function () {
            primePlay(retriesLeft - 1);
          }, 140);
        });
      };
      primePlay(8);
    });
  }

  function reorderVideoSlide() {
    /* Re-order video slides to the position specified in metafields */
    const pg = window.eHS.productGallery;
    const gallery = document.querySelector('[data-pg]');
    if (!pg || !pg.data || !gallery) return;

    const mainSlides = gallery.querySelector('[data-pg-main-slides]');
    const thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    if (!mainSlides || !thumbSlides) return;

    const buybox = window.eHS && window.eHS.productBuyBox;
    const variantId = buybox && buybox.currentVariant && buybox.currentVariant.id;

    const videoEntries = [
      { scope: 'product', originIndex: 'custom-video' },
      { scope: 'variant', originIndex: 'variant-video' }
    ];

    videoEntries.forEach(function (entry) {
      let videoPosition = 2;
      pg.data.forEach(function (item) {
        if (!item.video || item.video_scope !== entry.scope || !item.video_position) return;
        if (entry.scope === 'variant') {
          if (!variantId || !item.variants || !item.variants.includes(variantId)) return;
        }
        videoPosition = item.video_position;
      });

      if (videoPosition <= 0 || !gallery.querySelector('[data-origin-index="' + entry.originIndex + '"]')) return;

      if (videoPosition < mainSlides.children.length) {
        const videoInMainSlides = mainSlides.querySelector('[data-origin-index="' + entry.originIndex + '"]');
        if (videoInMainSlides) {
          const afterVideoSlide = mainSlides.children[videoPosition - 1];
          mainSlides.insertBefore(videoInMainSlides, afterVideoSlide);
        }
      }

      if (videoPosition < thumbSlides.children.length) {
        const videoInThumbSlides = thumbSlides.querySelector('[data-origin-index="' + entry.originIndex + '"]');
        if (videoInThumbSlides) {
          const afterVideoThumb = thumbSlides.children[videoPosition - 1];
          thumbSlides.insertBefore(videoInThumbSlides, afterVideoThumb);
        }
      }
    });
  }

  function updateVariantVideoSlide() {
    const pg = window.eHS && window.eHS.productGallery;
    const buybox = window.eHS && window.eHS.productBuyBox;
    const gallery = document.querySelector('[data-pg]');
    if (!pg || !buybox || !buybox.currentVariant || !gallery || gallery.hasAttribute('data-gift-pg')) return;

    const mainSlides = gallery.querySelector('[data-pg-main-slides]');
    const thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    if (!mainSlides || !thumbSlides) return;

    mainSlides.querySelectorAll('[data-origin-index="variant-video"]').forEach(function (el) {
      el.remove();
    });
    thumbSlides.querySelectorAll('[data-origin-index="variant-video"]').forEach(function (el) {
      el.remove();
    });

    const variantId = buybox.currentVariant.id;
    const variantVideo = pg.data && pg.data.find(function (item) {
      return item.video && item.video_scope === 'variant' && item.variants && item.variants.includes(variantId);
    });

    if (!variantVideo) {
      document.dispatchEvent(new CustomEvent('buybox:galleryrendered'));
      return;
    }

    const posterSrc = variantVideo.poster || '';
    const mainSlide = document.createElement('div');
    mainSlide.className = 'product-video w-full';
    mainSlide.setAttribute('data-origin-index', 'variant-video');
    mainSlide.innerHTML =
      '<div class="w-full relative flex items-center justify-center h-full">' +
        (posterSrc ? '<img src="' + posterSrc + '" alt="variant video" class="absolute inset-0 w-full h-full object-contain -z-1" loading="lazy" />' : '') +
        '<video id="gallery_variant_video" class="relative z-1 w-full h-full object-contain opacity-100 visible" loop playsinline preload="metadata">' +
          '<source src="' + variantVideo.video + '" type="video/mp4">' +
          'Your browser does not support the video tag.' +
        '</video>' +
      '</div>';

    const thumbSlide = document.createElement('div');
    thumbSlide.className = 'thumbnail thumbnail--video relative';
    thumbSlide.setAttribute('data-origin-index', 'variant-video');

    const youtubeMain = mainSlides.querySelector('[data-origin-index="video"]');
    const youtubeThumb = thumbSlides.querySelector('[data-origin-index="video"]');

    if (youtubeMain) {
      mainSlides.insertBefore(mainSlide, youtubeMain);
    } else {
      mainSlides.appendChild(mainSlide);
    }

    if (youtubeThumb) {
      thumbSlides.insertBefore(thumbSlide, youtubeThumb);
    } else {
      thumbSlides.appendChild(thumbSlide);
    }

    document.dispatchEvent(new CustomEvent('buybox:galleryrendered'));
  }
  
  // Function to scroll to first slide and reset gallery
  function scrollToFirstSlide() {
    const gallery = document.querySelector('[data-pg]');
    if (!gallery) return;
    
    const mainSlides = gallery.querySelector('[data-pg-main-slides]');
    const thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    
    if (!mainSlides || !thumbSlides) return;
    
    // First, ensure video slide exists
    ensureVideoSlide();
    
    // Wait for slides to be populated
    setTimeout(() => {
      const slides = Array.from(mainSlides.children).filter(slide => slide.dataset.originIndex);
      if (slides.length === 0) return;
      
      const firstSlide = slides[0];
      if (!firstSlide) return;
      
      // Scroll to first slide
      firstSlide.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'start'
      });
      
      // Update active states
      Array.from(mainSlides.children).forEach(slide => slide.classList.remove('active'));
      Array.from(thumbSlides.children).forEach(thumb => thumb.classList.remove('active'));
      
      firstSlide.classList.add('active');
      const firstThumb = thumbSlides.querySelector(`[data-origin-index="${firstSlide.dataset.originIndex}"]`);
      if (firstThumb) {
        firstThumb.classList.add('active');
      }
      
      // Update model info
      const modelInfo = firstSlide.dataset.modelInfo;
      const modelInfoElement = gallery.querySelector('[data-pg-model-info]');
      if (modelInfoElement) {
        modelInfoElement.innerHTML = modelInfo ? decodeURIComponent(modelInfo) : '';
      }
    }, 200);
  }
  
  // Listen for variant change events
  let previousVariant = null;
  document.addEventListener('buybox:variantChanged', function(e) {
    const gallery = document.querySelector('[data-pg]');
    if (gallery && gallery.hasAttribute('data-gift-pg')) return; // Gift cards: no gallery rebuild on variant change

    const currentVariant = e.detail && e.detail.data ? e.detail.data : null;
    
    if (currentVariant && previousVariant && currentVariant.options && previousVariant.options) {
      const colorChanged = currentVariant.options[0] !== previousVariant.options[0];
      const variantChanged = currentVariant.id !== previousVariant.id;
      
      if (colorChanged) {
        // Ensure video slide exists immediately
        ensureVideoSlide();
        // Wait a bit for gallery to rebuild, then scroll to first slide
        setTimeout(() => {
          ensureVideoSlide(); // Check again after rebuild
          scrollToFirstSlide();
        }, 400);
      } else if (variantChanged) {
        updateVariantVideoSlide();
      }
    }
    if (currentVariant) {
      previousVariant = currentVariant;
    }

    // setTimeout(() => {
    //   reorderVideoSlide();
    // }, 250);
  });

  document.addEventListener('buybox:galleryrendered', function(e) {
    reorderVideoSlide();
  });
  
  // Re-initialize when gallery is rebuilt (for variant changes)
  document.addEventListener('DOMContentLoaded', function() {
    const gallery = document.querySelector('[data-pg]');
    if (gallery) {
      let isRebuilding = false;
      let rebuildTimeout;
      
      const mutationObserver = new MutationObserver(function(mutations) {
        if (gallery.hasAttribute('data-gift-pg')) return; // Gift cards: skip gallery rebuild logic

        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            const mainSlides = gallery.querySelector('[data-pg-main-slides]');
            if (!mainSlides) return;
            
            // Check if video slide was removed
            const videoSlideRemoved = Array.from(mutation.removedNodes).some(node => 
              node.nodeType === 1 && 
              (node.classList.contains('product-video') || 
               node.getAttribute('data-origin-index') === 'video' ||
               node.querySelector && node.querySelector('[data-origin-index="video"]'))
            );
            
            // Check if slides were added (gallery rebuild)
            const hasNewSlides = mutation.addedNodes.length > 0 && Array.from(mutation.addedNodes).some(node => 
              node.nodeType === 1 && (node.classList.contains('product-image') || 
              node.classList.contains('product-video') || 
              node.classList.contains('product-custom-video'))
            );
            
            // If video was removed or new slides were added, ensure video exists
            if ((videoSlideRemoved || hasNewSlides) && !isRebuilding) {
              clearTimeout(rebuildTimeout);
              isRebuilding = true;
              
              rebuildTimeout = setTimeout(() => {
                // Ensure video slide exists after rebuild
                ensureVideoSlide();
                
                // Scroll to first slide when gallery rebuilds
                scrollToFirstSlide();
                syncThumbnailOnScroll();
                
                isRebuilding = false;
              }, 300);
            }
          }
        });
      });
      
      mutationObserver.observe(gallery, { childList: true, subtree: true });
      
      // Also periodically check for video slide (as a fallback)
      setInterval(function() {
        const gallery = document.querySelector('[data-pg]');
        if (gallery && gallery.dataset.videoId) {
          const mainSlides = gallery.querySelector('[data-pg-main-slides]');
          if (mainSlides) {
            const videoSlide = mainSlides.querySelector('[data-origin-index="video"]');
            if (!videoSlide) {
              ensureVideoSlide();
            }
          }
        }
      }, 1000);
    }
  });

  /** Prev/next arrows: cycle thumbnails by delegating to existing thumbnail click handler */
  function updateGalleryArrowVisibility(gallery) {
    var row = gallery.querySelector('[data-pg-controls-row]');
    var thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
    if (!row || !thumbSlides) return;
    var n = Array.from(thumbSlides.children).filter(function (c) {
      return c.dataset && c.dataset.originIndex;
    }).length;
    row.classList.toggle('product-gallery-controls-row--single', n < 2);
  }

  function initGalleryArrowNav() {
    document.querySelectorAll('[data-pg]').forEach(updateGalleryArrowVisibility);

    document.addEventListener('click', function (e) {
      var nextBtn = e.target.closest('[data-pg-nav-next]');
      var prevBtn = e.target.closest('[data-pg-nav-prev]');
      if (!nextBtn && !prevBtn) return;
      var gallery = (nextBtn || prevBtn).closest('[data-pg]');
      if (!gallery) return;
      var thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
      if (!thumbSlides) return;
      var thumbs = Array.from(thumbSlides.children).filter(function (el) {
        return el.dataset && el.dataset.originIndex;
      });
      if (thumbs.length < 2) return;
      e.preventDefault();
      var dir = nextBtn ? 1 : -1;
      var active = thumbs.find(function (t) {
        return t.classList.contains('active');
      });
      if (!active) active = thumbs[0];
      var i = thumbs.indexOf(active);
      if (i < 0) i = 0;
      var ni = (i + dir + thumbs.length) % thumbs.length;
      var targetThumb = thumbs[ni];
      if (!targetThumb) return;
      var wrapForward = dir === 1 && i === thumbs.length - 1;
      var wrapBackward = dir === -1 && i === 0;
      if (wrapForward || wrapBackward) {
        gallery.dispatchEvent(
          new CustomEvent('pg-loop-wrap', {
            detail: { originIndex: targetThumb.dataset.originIndex }
          })
        );
      } else {
        targetThumb.click();
      }
    });

    document.querySelectorAll('[data-pg]').forEach(function (gallery) {
      var thumbSlides = gallery.querySelector('[data-pg-thumb-slides]');
      if (!thumbSlides) return;
      var mo = new MutationObserver(function () {
        updateGalleryArrowVisibility(gallery);
      });
      mo.observe(thumbSlides, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryArrowNav);
    document.addEventListener('DOMContentLoaded', prewarmCustomMp4OnPdpEntry);
  } else {
    initGalleryArrowNav();
    prewarmCustomMp4OnPdpEntry();
  }
})();